if( !Array.from ){
  Array.from = function( object ){
    return Array.prototype.slice.call( object );
  };
}
